import { useRouter } from 'next/router';

/**
 * Returns language from the URL path.
 *
 * @returns language code
 */
export default function usePathLanguage(): string {
  const { query } = useRouter();
  const { language } = query;

  return language as string;
}
